import { Button, Checkbox, message, Page, Input } from 'components';
import { AuthContext } from 'contexts';
import styled from 'styled-components';
import axios from 'axios';
import React from 'react';
import moment from 'moment';

const OnboardingToolsPage = () => {
  const { auth } = React.useContext(AuthContext);
  const [userLoading, setUserLoading] = React.useState(false);
  const [resultLog, setResultLog] = React.useState<
    { timestamp: number; value: string }[]
  >([]);
  const [userId, setUserId] = React.useState(auth.id);
  const [shouldClaim, setShouldClaim] = React.useState(false);

  const _updateResults = (
    type: 'user',
    id: string,
    additionalMessage?: string,
  ) => {
    const result = `Successfully reset ${type} with ${id}`;
    const timestamp = moment().unix();
    const newResultLog = [
      ...resultLog,
      { timestamp, value: result },
      ...(additionalMessage ? [{ timestamp, value: additionalMessage }] : []),
    ];
    setResultLog(newResultLog);
  };

  const doAction = async ({
    id,
    type,
    additonalMessage,
    cb,
    loadingCb,
  }: {
    id: string;
    type: 'user';
    additonalMessage?: string;
    cb: (id: string) => Promise<void>;
    loadingCb: (loading: boolean) => void;
  }) => {
    try {
      loadingCb(true);
      await cb(id);
      _updateResults(type, id, additonalMessage);
    } catch (err) {
      message.error(err);
    } finally {
      loadingCb(false);
    }
  };

  const handleResetUser = async () => {
    doAction({
      id: userId,
      type: 'user',
      cb: async id => {
        await axios.post('/onboarding/qa_page/reset_user', {
          userId: id,
          shouldClaim,
        });
      },
      loadingCb: setUserLoading,
      additonalMessage: `New claim status: ${shouldClaim ? '' : 'un'}claimed`,
    });
  };

  return (
    <Page type="filled" title="Edit User isClaimed Status QA Page">
      <Layout>
        <StyledInput
          addonAfter={
            <Button
              disabled={userLoading}
              loading={userLoading}
              onClick={handleResetUser}
            >
              {shouldClaim ? 'Claim' : 'Unclaim'} User
            </Button>
          }
          onChange={e => setUserId(e.target.value)}
          placeholder="User Id"
          defaultValue={auth.id}
        />
        <Checkbox
          checked={shouldClaim}
          onChange={e => setShouldClaim(e.target.checked)}
        >
          Claim Status
        </Checkbox>
        {resultLog.length > 0 &&
          resultLog.map(result => (
            <div key={result.timestamp}>{`[${moment
              .unix(result.timestamp)
              .format('MM/DD/YYYY hh:mm a')}]: ${result.value}`}</div>
          ))}
      </Layout>
    </Page>
  );
};

export default OnboardingToolsPage;

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  padding: 20px;
  background: white;
`;

const StyledInput = styled(Input)`
  width: 500px;
`;
